module.exports = __webpack_public_path__ + "static/media/A3.17f2b91.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/A3.mp4
// module id = p4O8
// module chunks = 8